"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceSizeRangeToJSON = exports.AudienceSizeRangeFromJSONTyped = exports.AudienceSizeRangeFromJSON = exports.instanceOfAudienceSizeRange = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AudienceSizeRange interface.
 */
function instanceOfAudienceSizeRange(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceSizeRange = instanceOfAudienceSizeRange;
function AudienceSizeRangeFromJSON(json) {
    return AudienceSizeRangeFromJSONTyped(json, false);
}
exports.AudienceSizeRangeFromJSON = AudienceSizeRangeFromJSON;
function AudienceSizeRangeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'min': !(0, runtime_1.exists)(json, 'min') ? undefined : json['min'],
        'max': !(0, runtime_1.exists)(json, 'max') ? undefined : json['max'],
    };
}
exports.AudienceSizeRangeFromJSONTyped = AudienceSizeRangeFromJSONTyped;
function AudienceSizeRangeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'min': value.min,
        'max': value.max,
    };
}
exports.AudienceSizeRangeToJSON = AudienceSizeRangeToJSON;
